const common = require('./common.json');
const billing = require('./billing.json');
const places = require('./places.json');
const errors = require('./errors.json');

module.exports = Object.assign(common, billing, places, errors);
